var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatLeftText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3335 2.23535H2.66683C1.93043 2.23535 1.3335 2.83228 1.3335 3.56868V13.4306C1.3335 13.7276 1.69256 13.8763 1.90256 13.6663L3.8049 11.764C3.92996 11.6389 4.0995 11.5687 4.2763 11.5687H13.3335C14.0699 11.5687 14.6668 10.9718 14.6668 10.2354V3.56868C14.6668 2.83228 14.0699 2.23535 13.3335 2.23535ZM12.0002 9.40202H4.00016C3.7241 9.40202 3.50016 9.17809 3.50016 8.90202C3.50016 8.62595 3.7241 8.40202 4.00016 8.40202H12.0002C12.2762 8.40202 12.5002 8.62595 12.5002 8.90202C12.5002 9.17809 12.2762 9.40202 12.0002 9.40202ZM12.0002 7.40202H4.00016C3.7241 7.40202 3.50016 7.17808 3.50016 6.90202C3.50016 6.62595 3.7241 6.40202 4.00016 6.40202H12.0002C12.2762 6.40202 12.5002 6.62595 12.5002 6.90202C12.5002 7.17808 12.2762 7.40202 12.0002 7.40202ZM12.0002 5.40202H4.00016C3.7241 5.40202 3.50016 5.17808 3.50016 4.90202C3.50016 4.62595 3.7241 4.40202 4.00016 4.40202H12.0002C12.2762 4.40202 12.5002 4.62595 12.5002 4.90202C12.5002 5.17808 12.2762 5.40202 12.0002 5.40202Z",
    fill: "#16162C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLeftText);
export default __webpack_public_path__ + "static/media/chat-left-text.dbe90426fd324196e182165daf1d11a5.svg";
export { ForwardRef as ReactComponent };